<template>
    <div class="gong">
      <van-nav-bar
      title=""
      fixed
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    
    <div class="over">
      <div class="content">
        <ul >
         <li
            class="clearfix"
         @click="onSearch"
          
          >
            <img
              src="../../assets/pt/kda.png"
              alt=""
            >
            <p class="name">山东凯大新型材料科技有限公司</p>
            <p class="price">钢结构楼板 / 隔声板 / 硅藻阻燃板  </p>
            <div class="jin">
              <img src="../../assets/pt/40-1.png" alt="">
            </div>
            <p class="jies">山东凯大新型材料科技有限公司是一家集研发、生产、销售为一体的国家高新技术企业</p>
            <div class="jian">
              <img src="../../assets/pt/40.png" alt="">
            </div>
            <div class="can">
              <img src="../../assets/pt/01.jpg" alt="">
              <img src="../../assets/pt/02.jpg" alt="">
              <img src="../../assets/pt/03.jpg" alt="">

            </div>
          </li>
           <li
            class="clearfix"
         @click="onSearch1"
          
          >
            <img
              src="../../assets/pt/ka11.png"
              alt=""
            >
            <p class="name">众旺未来（上海）建材科技有限公司</p>
            <p class="price">Aismy装配式高隔声隔墙系统  </p>
            <div class="jin">
              <img src="../../assets/pt/40-1.png" alt="">
            </div>
            <p class="jies">聚焦内装工业化产品研发制造，赋能装配式内装企业系统营销与施工。打造全国装配基地服务站。</p>
            <div class="jian">
              <img src="../../assets/pt/40.png" alt="">
            </div>
            <div class="can">
              <img src="../../assets/pt/ka12.jpg" alt="">
              <img src="../../assets/pt/ka13.jpg" alt="">
              <img src="../../assets/pt/ka14.jpg" alt="">

            </div>
          </li>
        </ul>
      </div>
    </div>
   

    </div>
</template>
<script>
import Vue from 'vue'
import { Search,Swipe, SwipeItem,Picker,Popup, Tab, Tabs, Icon, Tabbar, TabbarItem, Lazyload, Toast,NavBar } from 'vant'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Lazyload).use(Swipe)
  .use(SwipeItem).use(Picker).use(Popup).use(NavBar)
 
export default {
   created(){
   setTimeout(()=>{
    console.log(12)
    this.$store.state.qdf=false
   },3000)
      this.axios.get("categoryList", { params: { store_id: this.$route.query.sd } }).then(res => {
      this.oneclass = res.data.data.list
      this.twoclass = res.data.data.son_list
      console.log(res)

    }).catch(ref => {
      // console.log(res)
    })
  },
    data() {
        return{
       oopupFlag:false ,
       statusNav:0,
       ctxt:'所属地',
     showPicker:false,
        columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      alls:false,
      oneclass:[],
      twoclass:[],
      qdf:true,
      value:''
        }
    },
    methods:{
        onSearch(){
          // console.log(this.value)
          this.$router.push('/gongx')
        },
        openAllClass () {
      
       this.alls=true
      },
      onClickLeft () {
      this.$router.go(-1)
    },
     addClass(){

        },
      goi(){
          this.$router.push('/')
        },
        onSearch1(){
          // console.log(this.value)
          this.$router.push('/gongd')
        },
      goc(){
        this.showPicker=true
      },
      onConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.ctxt=value
      this.showPicker=false
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast('取消');
    },
    close(){
      this.alls=false
    },
    }
}
</script>
<style lang="less" scoped>

.over{
  padding:0.2rem ;

  padding-top: 1.2rem;
    .content {
    flex: 1;
    
    ul {
      li {
        // float: left;
        // width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        margin: 0.2rem 0 0.5rem 0rem;
        img {
          width: 3.666667rem;
          float: left;
          margin-right: 0.2rem;
        }
        .price {
          height: 0.6rem;
          line-height: 0.6rem;
          font-size: 0.3rem;
          // color: #a22d2b;
          font-weight: 600;
          span{
            // text-align: right;
            padding-left: 1rem;
            color:#a8a5a5;
          }
        }
        .name {
          font-size: 0.4rem;
          color: #333;
           display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          font-weight: 600;
        }
        .jin{
          // width: 1.5rem;
          height: 0.7rem;
          img{
            width: 2.5rem;
          }
        }
        .jies{
           display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .jian{
          padding-top: 0.4rem;
          height: 1.2rem;

          img{
            width: 0.4rem;
          }
        }
        .can{
          img{
            float: left;
            width: 1.75rem;
            margin-right: 0.05rem;
          }
        }
      }
    }
  }
  }
</style>